import { useMutation } from '@tanstack/react-query';

import { authApi } from './auth-api';

export function useSignIn() {
  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      authApi.signInWithPassword(email, password),
  });
}

export function useSignUp() {
  return useMutation({
    mutationFn: ({
      email,
      password,
      phone,
      name,
    }: {
      email: string;
      password: string;
      phone: string;
      name: string;
    }) => authApi.signUp(email, password, phone, name),
  });
}

export function useSignOut() {
  return useMutation({
    mutationFn: authApi.signOut,
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: (email: string) => authApi.resetPassword(email),
  });
}

export function useUpdatePassword() {
  return useMutation({
    mutationFn: (password: string) => authApi.updatePassword(password),
  });
}